// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingBalanceResponse

export type BillingBalanceApiResponse = {
	available: number;
	pending: number;
	currency: string;
};

export type BillingBalance = {
	available: number;
	pending: number;
	currency: string;
};

export function hydrateBillingBalance(data: BillingBalanceApiResponse): BillingBalance {
	return { ...data };
}